module.exports = __webpack_public_path__ + "c984cce719e429a7370a6d792653e8f0.svg";